import React from "react";
import { EditReccurrenceFormView } from "./EditReccurrenceForm.view";

/**
 * Responsible for edit recurrence form logic
 */
export const EditReccurrenceForm: React.FC = () => {
  return (<EditReccurrenceFormView />);
};
